var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-wrap"},[_c('img',{attrs:{"src":require("@/assets/images/index/closed.png")}}),_c('h2',[_vm._v(_vm._s('网站已关闭'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }